/**
 * Created by wdzxc on 2017/4/20.
 */

const __origin__ = "http://dove.zol.com.cn";
// const __origin__ = "http://localhost:3233";


import {$wd, $Dialog, $Loading, InterfaceProxy} from '../src/index.js';
import $ from 'jquery';
// --- $Dialog ---
// $Dialog.alert("测试测试一段文字！测试测试一段文字！测试测试一段文字！测试测试一段文字！测试测试一段文字！测试测试一段文字！测试测试一段文字！测试测试一段文字！测试测试一段文字！测试测试一段文字！");

window.$wd = $wd;

InterfaceProxy.setDefault({
    dataFilter: (data, type) => {
        console.log(data);
        return data;
    },
    errCallback: msg => {
        console.log("default fail : " + msg);
    }
});

// --- InterfaceProxy ---
let interfaceOpt = {
    // //
    // getUserInfo: {
    //     // name: "获取用户信息",
    //     pathname: "/pin/web/getUserInfoAPI",
    //     dataType: "json",
    //     origin: "http://dove.zol.com.cn"
    // },
    //
    // /**
    //  * 配货单打印
    //  * @namespace OutStock.printDistribution
    //  */
    // getPackagePrintHtml: {
    //     pathname: "/wms/outPackage/printDistribution",
    //     origin: __origin__,
    //     type: "get",
    //     dataType: "jsonp",
    //     traditional: false,
    //     params: {
    //         id: null,  //包裹ID
    //     },
    //     returns: {}
    // },
    // getJson: {
    //     pathname: "/json/wdzxc",
    //     dataType: "jsonp",
    //     jsonp: "callback",
    //     origin: "http://localhost:3233",
    //     validTime: 1,
    // },
    // getError: {
    //     pathname: "/json/error",
    //     dataType: "jsonp",
    //     jsonp: "callback",
    //     origin: "http://localhost:3233",
    // },
    // postJson: {
    //     pathname: "/json/wdzxc",
    //     type: 'post',
    //     dataType: "json",
    //     origin: "http://localhost:3233",
    //     validTime: 1,
    // },
    jsonpRequest: {
        dataType: "jsonp",
        jsonp: "callback",
    },


    getOrderProducts:{},
    getOrderList: {
        returns: [{
            id: null,
            owner: null,
            products: function () {
                return "getOrderProducts"
            }
        }]
    },

    getJsonTest: {
        pathname: "/json/test",
        dataType: "jsonp",
        jsonp: "callback",
        origin: "http://localhost:3233",
        merge: true,
        // queue: true,
        // single: true,
        loading: "加载中...",
        paramsFilter: function (data) {
            console.log(data);
            data.p = 998;
            return data;
        }
    },

    getJsonTestMixin1: {
        mixins: "getJsonTest",
        loading: false
    },

    getJsonTestMixin2: {
        mixins: ["jsonpRequest", "getJsonTestMixin1"],
        loading: false,
        merge: false,
    },

};
// 接口初始化
window.iProxy = new InterfaceProxy(interfaceOpt, {
    errCallback: function (msg) {
        console.log("opt fail");
    },
    dataFilter: function (data) {
        return data;
    },
    params:{
        aaa:998
    }
    // ajax: $.ajax
});

iProxy.getJsonTest.$options.paramsFilter = function (data) {
    data.p = 233;
    return data;
};


// // before send
// iProxy.getJsonTestMixin2({
//     p: 1
// }, data => {
//     console.log(data);
// });

//
// const loadingElem = document.getElementById("loadingElem");
// const switchGroup = {
//     _switch1: false,
//     get switch1() {
//         if (this._switch1) {
//             loadingElem.innerHTML = "加载中";
//         } else {
//             loadingElem.innerHTML = "加载完毕";
//         }
//         return this._switch1;
//     },
//     set switch1(value) {
//         if (value) {
//             loadingElem.innerHTML = "加载中";
//         } else {
//             loadingElem.innerHTML = "加载完毕";
//         }
//         this._switch1 = value;
//     }
// };

// iProxy.getJsonTest({p: 1}, function (data) {
//     console.log("1号请求:", data);
// });
// iProxy.getJsonTest({p: 2}, function (data) {
//     console.log("2号请求:", data);
// });
// iProxy.getJsonTest({p: 2}, function (data) {
//     console.log("2号请求2:", data);
// });
// iProxy.getJsonTest({p: 2}, function (data) {
//     console.log("2号请求3:", data);
// }).finally(function () {
//     console.log("2号请求3 finally");
// });
// iProxy.getJsonTest({p: 3}).then(function (data) {
//     console.log("3号请求:", data);
// });
// iProxy.getJsonTest({p: 4}, function (data) {
//     console.log("4号请求:", data);
// });
// iProxy.getJsonTest({p: 5}, function (data) {
//     console.log("5号请求:", data);
// }).loadingSwitch(switchGroup, 'switch1');


// console.log($wd.objCover({a: 1, b: 2, c: 3}, {a: 11,cc:33, d: 22},'one-to-one'));

// iProxy.postJson({a:123},data=>{
//     console.log(data);
// });

// (async function test() {
//     var data2 = await iProxy.async.getJsonTest();
//     var data1 = await iProxy.async.getJson();
//     console.log(11, data1);
//     console.log(22, data2);
// })().then(() => {
//     console.log('end!!');
// }).catch(error => {.then1
//     console.log(error);
// });
window.$toolkit = iProxy.$toolkit;
// // iProxy.getJson(data => {
// iProxy.getError(data => {
//     console.log("capture then", data);
// }, msg => {
//     console.log("capture error: ", msg);
//     return true;
// }).then(data => {
//     console.log('then:', data);
// }).error(msg => {
//     console.log('error:', msg);
// }).finally(data => {
//     console.log('finally:', data);
//     return true;
// });


// iProxy.getJsonTest(data => {
//     console.log(111,data);
// }).getJsonTest(data => {
//     console.log(222,data);
// }).getJson(data => {
//     console.log(333,data);
// }).getJson(data => {
//     console.log(444,data);
// }).getJsonTest(data => {
//     console.log(555,data);
// });


// iProxy.getJson(data => {
//     console.log(1,data);
// }).getJsonTest(data => {
//     console.log(2,data);
// }).getJson(data => {
//     console.log(3,data);
// }).getJsonTest(data => {
//     console.log(4,data);
// }).getJson(data => {
//     console.log(5,data);
// }).then(()=>{
//     iProxy.getJson(data => {
//         console.log(6,data);
//     })
// });

// iProxy.getJson(data => {
//     console.log(111,data);
// }).then(() => {
//     iProxy.getJsonTest(data=>{
//         console.log(111,data);
//     });
// });
// iProxy.getJson(data => {
//     console.log(222,data);
// }).then(() => {
//     iProxy.getJsonTest(data=>{
//         console.log(222,data);
//     });
// });

//
// function tlcmTest() {
//     $Dialog.alert("test");
//     $Dialog.confirm("test");
//     $Dialog.notify("test");
//     $Dialog.soundNotify(1);
// }

// (async function test() {
//     var data2 = await iProxy.getJsonTest();
//     // var data1 = await iProxy.getJsonTest({fail:false});
//     var data1 = await iProxy.getJsonTest({success:true});
//     console.log(11, data1);
//     console.log(22, data2);
// })().then(() => {
//     console.log('end!!');
// }).catch(error => {
//     console.log(error);
// });

iProxy.async.getJsonTest({fail:true}).then(data=>{
    console.log(data);
}).then(data=>{
    console.log(data);
},err=>{
    console.log('err0',err);
}).catch(err=>{
    console.log('err1',err);
}).catch(err=>{
    console.log('err2',err);
});